<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
                <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />董监高列表</el-col>
            <el-col :xs="24" :md="18">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
                    
                     <el-form-item>
						<el-button class="addBtn" type="primary" @click="handleEdit()">{{ $t('add') }}</el-button>
                    </el-form-item>
                    <el-form-item>
						<el-button class="delBtn" type="danger"  @click="handleDele()">{{ $t("deleteBatch") }}</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div class="mod-user__leader-list">
            <el-form :inline="true" ref="searchForm" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item label="公司名称" style="margin-top: 20px;margin-left: 20px;">
                    <el-input v-model="dataForm.caName" placeholder="输入公司名称查询" clearable></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 20px;margin-left: 20px;">
                    <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item style="margin-top: 20px;margin-left: 20px;">
                    <el-button type="refreshBtn" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column label="序号" type="index" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{(page - 1) * limit + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="编码" header-align="center" align="center"></el-table-column>
                <el-table-column prop="name" label="姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="idCard" label="身份证" header-align="center" align="center"></el-table-column>
                <el-table-column prop="caName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="typeJoin" label="职位" header-align="center" align="center"></el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('update') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                background
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
         <!-- 弹窗, 新增 / 修改 -->
        <djgEdit v-if="grUpdateVisible" ref="djgEdit" @refreshDataList="getDataList()" :dataForm="listDetail"></djgEdit>
    </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import djgEdit from './djg-edit.vue'
export default {
    name: "leader-list",
    mixins: [mixinViewModule],
    components:{djgEdit},
    data () {
        return {
            listDetail:{
                code:'',
                name:'',
                phone:'',
                idCard:'',
                caName:'',
                typeJoin:'',
            },
            grUpdateVisible:false,
            dataListSelections:[],
            mixinViewModuleOptions: {
                getDataListURL: '/sys/companyStaff/page',
                getDataListIsPage: true,
                deleteIsBatch: true,
                deleteURL: "/sys/companyStaff/delete",
                exportURL: '/sys/companyStaff/export'
            },
            dataForm: {
                caName: ''
            }
        }
    },
    methods: {
        handleEdit(row){
            this.grUpdateVisible = true
            if(row){
                this.listDetail = row;
                this.$nextTick(() => {
                    this.$refs.djgEdit.isAdd = false;
                    this.$refs.djgEdit.init()
                })
            }else{
                this.listDetail = {
                    code:'',
                    name:'',
                    phone:'',
                    idCard:'',
                    caName:'',
                    typeJoin:'',
                }
                this.$nextTick(() => {
                    this.$refs.djgEdit.isAdd = true;
                    this.$refs.djgEdit.init()
                })
            }
        },
        // 多选
        dataListSelectionChangeHandle (val) {
            this.dataListSelections = val
            this.dataListSelectionid = val.map((item) => {
                return item.id;
            })
        },
        handleDele(){
            console.log(this.dataListSelections.map(item => item['id']))
            if (this.dataListSelections.length <= 0) {
                return this.$message({
                message: this.$t('prompt.deleteBatch'),
                type: 'warning',
                duration: 500
                })
            }
            this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                this.$http.post('/sys/companyStaff/delete',this.dataListSelections.map(item => item['id'])).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                    this.query()
                    }
                })
                }).catch(() => {})
            }).catch(() => {})
        },
        handleReset(){
            this.dataForm.caName = "";
            this.getDataList()
        }
    }
}
</script>

<style scoped>
.mod-user__leader-list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-form {
    flex-shrink: 0;
  }
  
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>